import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Toastr } from "@revvsales/components";
import Modal from "react-responsive-modal";

import { tagDescriptionMapping } from "../../../../constants/metalens";

const DocumentReviewClausesFilter = ({
  show,
  onClose,
  perClauseAnalysisIndex,
  currentAnalysis,
  applyFilters,
  getNewFilters,
  resetAnalysis,
}) => {
  const [clauseFilters, setClauseFilters] = useState([]);
  const [allFilterStatus, setAllFilterStatus] = useState(false);

  useEffect(
    () => {
      if (perClauseAnalysisIndex && currentAnalysis) {
        const newFilters = getNewFilters();
        setClauseFilters(newFilters);
      }
    },
    [perClauseAnalysisIndex, currentAnalysis, getNewFilters],
  );

  const _changeStatus = index => {
    setClauseFilters(
      clauseFilters.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            status: !item.status,
          };
        }
        return item;
      }),
    );
  };

  const _changeAllStatus = () => {
    setClauseFilters(
      clauseFilters.map(item => ({ ...item, status: !allFilterStatus })),
    );

    setAllFilterStatus(!allFilterStatus);
  };

  const _resetFilters = () => {
    resetAnalysis();
    setAllFilterStatus(false);
    Toastr.showToastr({
      type: "success",
      message: "Filter(s) have been reset ",
      timeout: 3000,
    });
  };

  return (
    <Modal
      classNames={{
        modal: "documentreviewclauses-filter-modal",
      }}
      open={show}
      onClose={onClose}
      center>
      <div
        data-belongsto="metalens-dropdown"
        className="documentreviewclauses-filter">
        <div className="documentreviewclauses-filter-inner-wrapper">
          <div
            data-belongsto="metalens-dropdown"
            className="documentreviewclauses-filter-head">
            <div
              className="documentreviewclauses-filter-head-title"
              data-belongsto="metalens-dropdown">
              <span>
                <FontAwesomeIcon icon={["fas", "filter"]} className="" />
              </span>{" "}
              {"  "}
              Filter clauses that you would like to review
            </div>
          </div>
          <div
            data-belongsto="metalens-dropdown"
            className="documentreviewclauses-filter-body">
            <div
              className="documentreviewclauses-filter-item"
              data-belongsto="metalens-dropdown">
              <span
                data-belongsto="metalens-dropdown"
                className="assetitem-checkbox-wrapper">
                <label
                  data-belongsto="metalens-dropdown"
                  htmlFor="all-filter-id"
                  id=""
                  className="documentreviewclauses-filter-item-container">
                  All
                  <input
                    data-belongsto="metalens-dropdown"
                    data-test="all-filter"
                    onChange={() => {
                      _changeAllStatus();
                    }}
                    id="all-filter-id"
                    type="checkbox"
                    checked={allFilterStatus}
                  />
                  <span
                    data-belongsto="metalens-dropdown"
                    className="documentreviewclauses-filter-item-checkmark"
                  />
                </label>
              </span>
              <div className="documentreviewclauses-filter-item-description">
                See all clauses
              </div>
            </div>
            {clauseFilters &&
              clauseFilters.map((item, ind) => (
                <div
                  key={`${item.id}-filter`}
                  className="documentreviewclauses-filter-item"
                  data-belongsto="metalens-dropdown">
                  <span data-belongsto="metalens-dropdown" className="">
                    <label
                      data-belongsto="metalens-dropdown"
                      htmlFor={`${item.clause}-filter-id`}
                      id=""
                      className="documentreviewclauses-filter-item-container">
                      {item.clause}
                      <input
                        data-belongsto="metalens-dropdown"
                        data-test={`${item.clause}-filter`}
                        onChange={() => {
                          _changeStatus(ind);
                        }}
                        id={`${item.clause}-filter-id`}
                        type="checkbox"
                        checked={item.status}
                      />
                      <span
                        data-belongsto="metalens-dropdown"
                        className="documentreviewclauses-filter-item-checkmark"
                      />
                    </label>
                  </span>
                  <div
                    data-belongsto="metalens-dropdown"
                    className="documentreviewclauses-filter-item-description">
                    {tagDescriptionMapping[item.clause] || ""}
                  </div>
                </div>
              ))}
          </div>
        </div>
        <div className="documentreviewclauses-filter-footer">
          <div>
            <Button
              data-test="documentreviewclauses-filter-reset-btn"
              data-belongsto="metalens-dropdown"
              className="documentreviewclauses-filter-reset-btn"
              onClick={_resetFilters}
              id="documentreviewclauses-filter-reset-btn-1">
              <span>
                <FontAwesomeIcon icon={["far", "undo"]} className="" />
              </span>
              &nbsp; Reset Filter
            </Button>
          </div>
          <div className="">
            <Button
              data-test="documentreviewclauses-filter-cancel-btn"
              data-belongsto="metalens-dropdown"
              className="documentreviewclauses-filter-cancel-btn"
              onClick={onClose}
              id="documentreviewclauses-filter-cancel-btn-1">
              &nbsp; Cancel
            </Button>
            <Button
              data-test="documentreviewclauses-filter-apply-btn"
              data-belongsto="metalens-dropdown"
              className="documentreviewclauses-filter-apply-btn"
              onClick={event => {
                applyFilters(clauseFilters);
                onClose(event);
              }}
              id="documentreviewclauses-filter-apply-btn-1">
              &nbsp; Apply
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DocumentReviewClausesFilter;



// WEBPACK FOOTER //
// ./src/components/QuickReview/DocumentReviewSection/DocumentReviewClauses/DocumentReviewClausesFilter.js